var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "38px",
    viewBox: "0 0 39 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow_down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Client",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-168.000000, -717.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_down",
    transform: "translate(187.342105, 736.000000) rotate(-270.000000) translate(-187.342105, -736.000000) translate(168.342105, 717.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,-2.13162821e-14 C8.50680469,-2.13162821e-14 -5.68434189e-14,8.50680469 -5.68434189e-14,19 C-5.68434189e-14,29.4931953 8.50680469,38 19,38 C29.4931953,38 38,29.4931953 38,19 C38,8.50680469 29.4931953,-2.13162821e-14 19,-2.13162821e-14 Z",
    id: "Shape",
    fillOpacity: 0.11680507
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6825913,10.4393292 C16.0689246,9.85355693 15.0739168,9.85355693 14.46025,10.4393292 C13.8465833,11.0251015 13.8465833,11.9748809 14.46025,12.5606532 L21.2062381,19 L14.46025,25.4393468 C13.8465833,26.0251191 13.8465833,26.9748985 14.46025,27.5606708 C15.0739168,28.1464431 16.0689246,28.1464431 16.6825913,27.5606708 L24.53975,20.060662 C25.1534167,19.4748897 25.1534167,18.5251103 24.53975,17.939338 L16.6825913,10.4393292 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.c979dd1ca37ab03c864d122930352b52.svg";
export { ForwardRef as ReactComponent };